// extracted by mini-css-extract-plugin
module.exports = {"container":"_1sRgWV30sEoHLfc62zR2Vo","newSuggestedDishFields":"_2Qur-LAr6bdvSnU_GnTSSK"};